module.exports = __webpack_public_path__ + "static/media/29.eaa1804a.jpg";